import { KebabDining } from "@mui/icons-material";
import React from "react";
import "./Userhistory.css";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";
import { Token } from "../../../../../Script/Session";
import { post } from "../../../../../Script/Session";
const Userhistory =  ({ historyval, sethistory, id, page }) => {

            const navigate = useNavigate();

            const [data, setdata] = useState({});
            const [filteredata, setfilterdata] = useState({});
            const [offset, setoffset] = useState(0);
            
            function rendermore(){
                setoffset((prevOffset) => prevOffset + 1);

                let body = {
                    token: Token.get(),
                    action: "history",
                    offset: offset + 1,
                    target: "" + id,
                }
                let response = post(body,"/usermanagement")
                if (response == null) {
                    alert("Fehler in der NutzerVerwaltung");
                    return;
                }
                if (response == "LOGOUT"){
                    navigate("/");
                    return;
                }
                if (response == "NOPERMISSION"){
                    alert("Fehlende Berechtigung");
                    return;
                }
                let json = JSON.parse(response);
                console.log(json.value);
                setfilterdata([...filteredata,...json.value]);
            }


            useEffect(() => {
                const fetchData = async () => {
                    setLoading(true);
                    try {
                        let body = {
                            token: Token.get(),
                            action: "history",
                            offset: offset,
                            target: "" + id,
                        }
                        let response = post(body,"/usermanagement")
                        if (response == null) {
                            alert("Fehler in der NutzerVerwaltung");
                            return;
                        }
                        if (response == "LOGOUT"){
                            navigate("/");
                            return;
                        }
                        if (response == "NOPERMISSION"){
                            alert("Fehlende Berechtigung");
                            return;
                        }
                        let json = JSON.parse(response);
                        setdata(json);
                        setfilterdata(json.value);
                        console.log(json.value);
                    } catch (error) {
                        console.error("Error fetching data:", error);
                    } finally {
                        setLoading(false);
                    }
                };
            
                    // Delay fetch slightly to avoid blocking render
                setTimeout(() => {
                    fetchData();
                }, 0); // Immediate but non-blocking
            }, [navigate]);
            const [loading, setLoading] = useState(true);
            const handleScroll = (event) => {
                const ul = event.target;
                if (ul.scrollTop + ul.clientHeight >= ul.scrollHeight) {
                  //setAtBottom(true); // Scrolled to the bottom
                  console.log("bottom")
                } else {
                  //setAtBottom(false); // Not scrolled to the bottom
                }
              };
            function close() {
                sethistory(false);


            }

            return (
                <div className="userdatahistory-verwaltung" onContextMenu={() => {}}>
                    <div className="header-userhistory">
                        <text>Historie</text>
                        <text 
                            onClick={close} 
                            style={{ color: "red", marginRight: "15px", marginTop: "5px", cursor: "pointer" }}
                        >
                            X
                        </text>
                    </div>
            
                    {loading ? (
                        <p>Loading groups...</p> 
                    ) : filteredata.length === 0 ? (
                        <p style={{ marginLeft: "1%", color: "#c1d2dd" }}>Keine Historie Gefunden</p> 
                    ) : data.value.length > 0 ? (
                        <ul  className="userdatahistory-verwaltung-ul">
                            {filteredata.map((item, index) => (
                                <li 
                                    key={index} 
                                    title={item.page} 
                                    onClick={() => navigate(item.page)} 
                                    className="userdatahistory-verwaltung-ul-li"
                                    style={{ width: "100%" }}
                                >
                                    <p>{item.time}</p>
                                    <p>{item.name}</p>
                                    <p>{item.desc}</p>
                                    {(page !== "/verwaltung-nutzer-verwalten" && page !== "/") && (
                                        <button onClick={() => { navigate(page); }} className="jumpbuttonhistory">
                                            Springen
                                        </button>
                                    )}
                                    
                                </li>
                            ))}
                          <button className="moreloadbutton" onClick={rendermore}>Mehr Laden</button>
                        </ul>
                    ) : (
                        <p>No User available</p>
                    )}
                </div>
            );



}
export default Userhistory;